import { PlanoFixo } from '@/service/api'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Divider, Tab } from '@mui/material'
import ContentGuide from 'global/guides/ContentGuide'
import { usePlanosContext } from 'pages/Planos'
import React, { useMemo, useState } from 'react'
import { PlanosCard } from './components/PlanosCard'

type TipoPlanos = 'mensal' | 'trimestral' | 'anual'

type Data = {
    mensal: PlanoFixo[]
    anual: PlanoFixo[]
    trimestral: PlanoFixo[]
}

const STATUS_ATIVOS_PENDENTES = ['active', 'waitingPayment']

export const Planos: React.FC = () => {
    const { planos, assinatura, PlanoDiferenciado } = usePlanosContext()
    const [value, setValue] = useState<TipoPlanos>('mensal')

    const { anual, mensal, trimestral } = useMemo<Data>(() => {
        if (planos) {
            return {
                anual: planos.filter(plano => plano.periodicity === 'yearly'),
                mensal: planos.filter(plano => plano.periodicity === 'monthly'),
                trimestral: planos.filter(
                    plano => plano.periodicity === 'quarterly',
                ),
            }
        }

        return { mensal: [], anual: [], trimestral: [] }
    }, [planos])

    const handleChange = (_: React.SyntheticEvent, newValue: TipoPlanos) => {
        setValue(newValue)
    }

    if (PlanoDiferenciado)
        return (
            <ContentGuide>
                <PlanosCard
                    planos={[
                        {
                            limiteFuncionarios: 0,
                            periodicity: PlanoDiferenciado.periodicidade,
                            price: PlanoDiferenciado.valorCentavos,
                        },
                    ]}
                    trocar={STATUS_ATIVOS_PENDENTES.includes(
                        assinatura?.status || '',
                    )}
                />
            </ContentGuide>
        )

    return (
        <TabContext value={value}>
            <div className="flex flex-col px-0 sm:px-4 md:px-8 h-[calc(100vh-4rem)] overflow-hidden">
                <div className="border-b w-full md:pt-4 h-fit">
                    <TabList
                        onChange={handleChange}
                        aria-label="Todos os planos"
                        centered
                        variant="fullWidth"
                    >
                        <Tab label="Planos mensais" value="mensal" />
                        <Divider
                            orientation="vertical"
                            variant="middle"
                            flexItem
                        />
                        <Tab label="Planos trimestrais" value="trimestral" />
                        <Divider
                            orientation="vertical"
                            variant="middle"
                            flexItem
                        />
                        <Tab label="Planos anuais" value="anual" />
                    </TabList>
                </div>
                <div className="overflow-y-auto overflow-x-hidden flex-1">
                    <TabPanel
                        value="mensal"
                        className="p-1 md:p-4 max-h-full mt-0"
                    >
                        <PlanosCard
                            planos={mensal}
                            trocar={STATUS_ATIVOS_PENDENTES.includes(
                                assinatura?.status || '',
                            )}
                        />
                    </TabPanel>
                    <TabPanel
                        value="trimestral"
                        className="p-1 md:p-4 max-h-full mt-0"
                    >
                        <PlanosCard
                            planos={trimestral}
                            trocar={STATUS_ATIVOS_PENDENTES.includes(
                                assinatura?.status || '',
                            )}
                        />
                    </TabPanel>
                    <TabPanel
                        value="anual"
                        className="p-1 md:p-4 max-h-full mt-0"
                    >
                        <PlanosCard
                            planos={anual}
                            trocar={STATUS_ATIVOS_PENDENTES.includes(
                                assinatura?.status || '',
                            )}
                        />
                    </TabPanel>
                </div>
            </div>
        </TabContext>
    )
}
